import { CommentTextMultipleIcon } from './CommentTextMultipleIcon';

/**
 * author: Michael Richins
 * id 88EDEE2E-AB1B-4287-A082-E3B139F8E69A
 * name comment-text-multiple
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-text-multiple.svg
 * tags
 */
export const CommentsTextIcon = CommentTextMultipleIcon;
export default CommentsTextIcon